import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, User, LogOut } from "lucide-react";
import { Button } from "./ui/button";
import { authService } from "../services/api";

export const Navbar = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = () => {
    const token = localStorage.getItem("token");
    const userData = authService.getUser();
    if (token && userData) {
      setIsLoggedIn(true);
      setUser(userData);
    }
  };

  const handleLogout = () => {
    authService.logout();
    setIsLoggedIn(false);
    setUser(null);
    navigate("/");
    setIsMenuOpen(false);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/">
            <img 
              src="https://customer-assets.emergentagent.com/job_proplandpro/artifacts/d99lgtpt_inmopages-fondoblanco.png" 
              alt="InmoPages" 
              className="h-8"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection("funcionalidades")}
              className="text-gray-700 hover:text-brand-purple transition-colors font-medium"
            >
              Funcionalidades
            </button>
            <button
              onClick={() => scrollToSection("como-funciona")}
              className="text-gray-700 hover:text-brand-purple transition-colors font-medium"
            >
              Cómo Funciona
            </button>
            <button
              onClick={() => scrollToSection("precios")}
              className="text-gray-700 hover:text-brand-purple transition-colors font-medium"
            >
              Precios
            </button>
            
            {isLoggedIn ? (
              <>
                <Link to="/admin/dashboard">
                  <Button variant="ghost" className="flex items-center">
                    <User className="w-4 h-4 mr-2" />
                    {user?.name?.split(' ')[0] || 'Mi Panel'}
                  </Button>
                </Link>
                <Button 
                  variant="outline" 
                  onClick={handleLogout}
                  className="flex items-center"
                >
                  <LogOut className="w-4 h-4 mr-2" />
                  Salir
                </Button>
              </>
            ) : (
              <>
                <Link 
                  to="/login"
                  className="text-gray-700 hover:text-brand-purple transition-colors font-medium"
                >
                  Iniciar Sesión
                </Link>
                  <Button 
                    className="bg-brand-purple hover:bg-brand-pink text-white"
                    onClick={(e) => { 
                      e.preventDefault();
                      if (window.firePixelAndNavigate) {
                        window.firePixelAndNavigate('Lead', { content_name: 'Navbar Crear Cuenta' }, '/register');
                      } else {
                        window.location.href = '/register';
                      }
                    }}
                  >
                    Crear Cuenta
                  </Button>
              </>
            )}
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-700 hover:text-brand-purple transition-colors"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 space-y-3 border-t border-gray-200">
            <button
              onClick={() => scrollToSection("funcionalidades")}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-purple-50 hover:text-brand-purple transition-colors font-medium rounded"
            >
              Funcionalidades
            </button>
            <button
              onClick={() => scrollToSection("como-funciona")}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-purple-50 hover:text-brand-purple transition-colors font-medium rounded"
            >
              Cómo Funciona
            </button>
            <button
              onClick={() => scrollToSection("precios")}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-purple-50 hover:text-brand-purple transition-colors font-medium rounded"
            >
              Precios
            </button>
            
            {isLoggedIn ? (
              <>
                <Link
                  to="/admin/dashboard"
                  className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-purple-50 hover:text-brand-purple transition-colors font-medium rounded"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Mi Panel
                </Link>
                <div className="px-4 pt-2">
                  <Button 
                    variant="outline" 
                    className="w-full"
                    onClick={handleLogout}
                  >
                    <LogOut className="w-4 h-4 mr-2" />
                    Cerrar Sesión
                  </Button>
                </div>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-purple-50 hover:text-brand-purple transition-colors font-medium rounded"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Iniciar Sesión
                </Link>
                <div className="px-4 pt-2">
                  <Link to="/register" onClick={() => setIsMenuOpen(false)}>
                    <Button className="w-full bg-brand-purple hover:bg-brand-pink text-white">
                      Crear Cuenta
                    </Button>
                  </Link>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};
